import { Box, Select, MenuItem, SxProps, Theme, Chip } from "@mui/material";

export const DateHierarchy = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  column: string;
  setColumn: (column: string) => void;
  columns: { name: string; caption: string }[];
}) => {
  const { sx, column, setColumn, columns, isLoading } = props;

  const columnValid = columns.some((c) => c.name === column);

  return (
    <Box sx={sx}>
      <Box sx={{ fontSize: 11, mb: 0.1 }}>Display by</Box>
      <Select
        disabled={isLoading || !columnValid}
        variant="standard"
        size="small"
        // it's ok as long as we have only one level of hierarchy
        // which is what we aggreed on for now
        value={columnValid ? column : ""}
        renderValue={(value) => (
          <Chip
            key={value}
            label={columns.find((column) => column.name === value)?.caption}
            size="small"
            sx={{
              backgroundColor: "action.selected",
            }}
          />
        )}
        onChange={async (event) => {
          const newValue = event.target.value as string;
          setColumn(newValue);
        }}
      >
        {columns.map((column, index) => (
          <MenuItem key={index} value={column.name}>
            {column.caption}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
